const DevApiUrl = "https://api.liplep.ms.dev.payforsay.com/"
const ProdApiUrl = "https://gitapi.payforsay.com/"

export const backendUrl = process.env.NODE_ENV === 'development' ? DevApiUrl : ProdApiUrl
